import { render, staticRenderFns } from "./Root.vue?vue&type=template&id=6b95389b"
import script from "./Root.vue?vue&type=script&lang=ts"
export * from "./Root.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_css-loader@7.1.2_@rspack+core@1.7.1_@swc+he_cbaa080c91d062ed082faf804c1e065d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports